import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBookmark, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-save-reference',
  standalone: true,
  imports: [FormsModule, FontAwesomeModule, TranslateModule],
  templateUrl: './modal-save-reference.component.html',
  styleUrls: ['./modal-save-reference.component.scss']
})
export class ModalSaveReferenceComponent {
  @Input() show = false;
  @Input() loading = false;
  @Input() defaultName = '';

  @Output() close = new EventEmitter<void>();
  @Output() saved = new EventEmitter<string>();

  faBookmark = faBookmark;
  faTimes = faTimes;
  faCheck = faCheck;

  name = '';

  ngOnChanges(): void {
    this.name = this.defaultName;
  }

  onClose(): void {
    if (this.loading) {
      return;
    }
    this.close.emit();
  }

  onSave(): void {
    const trimmedName = this.name.trim();
    if (!trimmedName || this.loading) {
      return;
    }
    this.saved.emit(trimmedName);
  }
}
